import React from 'react';

export const DropDownTreeContext = React.createContext<{
  selectedFolder?: string;
  onSelect: (id: string) => void;
  onToggle: (id: string) => void;
  expandedFolders: string[];
}>({ onSelect: () => {}, onToggle: () => {}, expandedFolders: [] });

export const useDropDownTreeContext = () => {
  return React.useContext(DropDownTreeContext);
};
